import React from 'react';
import PropTypes from 'prop-types';
import {Animator} from '../Animator';
import {
  ORIENTATION,
  EVENT_RESIZE,
  DEFAULT_DIMENSION_UPDATE_EVENT,
  calculateDimentions,
  getMinSquareDimention,
  getMinWideDimention,
} from './AnimationBlocks.utils';
import {throttle} from '@learningblocks/exp-constants/lib/Utilities';

const animationBlockRef = React.createRef();

export function AnimationBlock(props) {
  const isOrientationAuto = () => props.orientation === ORIENTATION.AUTO;

  const [state, setState] = React.useState({
    orientation: isOrientationAuto() ? ORIENTATION.SQUARE : props.orientation,
    dimentions: isOrientationAuto()
      ? getMinSquareDimention()
      : props.orientation === ORIENTATION.WIDE
      ? getMinWideDimention()
      : getMinSquareDimention(),
  });

  const isBlockRefCurrent = () =>
    animationBlockRef && animationBlockRef.current;

  const onResize = (event) =>
    throttle(() => updateDimentionsAndOrientation(event));

  const updateDimentionsAndOrientation = ({target}) => {
    let orientation = state.orientation;
    let dimentions = state.dimentions;
    if (isOrientationAuto()) {
      const {innerHeight: height, innerWidth: width} = target;
      if (width > height) {
        orientation = ORIENTATION.WIDE;
      } else {
        orientation = ORIENTATION.SQUARE;
      }
    }
    if (isBlockRefCurrent()) {
      dimentions = calculateDimentions(animationBlockRef, orientation);
    }
    setState({dimentions, orientation});
  };

  React.useEffect(() => {
    updateDimentionsAndOrientation(DEFAULT_DIMENSION_UPDATE_EVENT);
    window.addEventListener(EVENT_RESIZE, onResize);
    return () => {
      window.removeEventListener(EVENT_RESIZE, onResize);
    };
  }, []);

  React.useEffect(() => {
    updateDimentionsAndOrientation(DEFAULT_DIMENSION_UPDATE_EVENT);
  }, [animationBlockRef.current]);

  const setAnimationData = () => props.src[state.orientation];

  return (
    <div className='imageslider_animationBlock' ref={animationBlockRef}>
      <Animator
        animationData={setAnimationData()}
        limits={[props.limits.min.value, props.limits.max.value]}
        current={props.current.value}
        width={`${state.dimentions.width}px`}
        height={`${state.dimentions.height}px`}
      />
    </div>
  );
}

AnimationBlock.propTypes = {
  /**
   * The animation file to be rendered
   */
  src: PropTypes.object,
  /**
   * The orientation for the animation
   */
  orientation: PropTypes.oneOf(['wide', 'square', 'auto']),
  /**
   * The max and min values to display on slider
   */
  limits: PropTypes.shape({
    /**
     * Data for point minimum
     */
    min: PropTypes.shape({
      /**
       * Value for the point
       */
      value: PropTypes.number,
      /**
       * Label for the point
       */
      label: PropTypes.string,
    }),
    /**
     * Data for point maximum
     */
    max: PropTypes.shape({
      /**
       * Value for the point
       */
      value: PropTypes.number,
      /**
       * Label for the point
       */
      label: PropTypes.string,
    }),
  }),
  /**
   * The current status of the slide
   */
  current: PropTypes.shape({
    /**
     * Value for the point
     */
    value: PropTypes.number,
    /**
     * Label for the point
     */
    label: PropTypes.string,
  }),
};
